(function () {
    'use strict';

    angular.module('app.departments', [
        'app.core',
        'app.widgets'
    ]);
})();
